import { CatalogBrowser } from '../components/CatalogBrowser';
import { seriesLink } from '../lib/links';

export function Series() {
  return <CatalogBrowser kind="series" title="Series" hrefFor={(accountId, stream) => seriesLink(accountId, stream.id)} />;
}
